// Dependencias
import axios from 'axios';

// Configuraciones
import { URL_API } from '../config/keys.config';
import { httpTokenInterceptor } from '../utils/httpTokenInterceptor';

// Instancias
const token = document.querySelector<HTMLInputElement>('#access-token')!.value;
const clientAxios = axios.create({
  baseURL: URL_API,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  }
});

clientAxios.interceptors.response.use((res) => res, httpTokenInterceptor);

export type FoliosRealTimeData = {
  availableFolios: number;
  totalAssignedFolios: number;
  assignedFoliosCurrentMonth: number;
  usersSaldoToday?: number;
  usedDocumentsHistoric?: number;
};

/**
 * Obtiene datos de folios para un mes específico (formato YYYY-MM)
 */
export async function fetchFoliosByMonth(month: string): Promise<FoliosRealTimeData | null> {
  try {
    const { data } = await clientAxios.get<FoliosRealTimeData>(
      '/folios-real-time',
      {
        params: { month }
      }
    );
    return data;
  } catch (error) {
    console.error('Error fetching folios by month:', error);
    return null;
  }
}

// Tipos para WHMCS Jobs
export type WhmcsSyncJob = {
  id: number;
  entity_type: string;
  entity_id: number;
  payload: any;
  status: string;
  attempts: number;
  last_error: string | null;
  next_retry: string;
  created_at: string;
  updated_at: string;
};

export type WhmcsSyncJobsResponse = {
  jobs: WhmcsSyncJob[];
  pagination: {
    totalItems: number;
    totalPages: number;
    currentPage: number;
    limit: number;
  };
};

type FetchWhmcsJobsParams = {
  token: string;
  page?: number;
  limit?: number;
  status?: string;
};

/**
 * Obtiene los jobs de WHMCS paginados y filtrados
 */
export async function fetchWhmcsJobs({ token, page = 1, limit = 10, status }: FetchWhmcsJobsParams): Promise<WhmcsSyncJobsResponse | null> {
  try {
    const params: any = { page, limit };
    if (status && status !== 'all') {
      params.status = status;
    }
    
    const { data } = await clientAxios.get<WhmcsSyncJobsResponse>('/panel/whmcs-jobs', {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params
    });
    
    return data;
  } catch (error) {
    console.error('Error fetching whmcs jobs:', error);
    return null;
  }
}


